import type { GQL_ID } from '@@partner:types:graphql'

import { gql } from '@apollo/client'

export interface ApplyPromocodeMutation {
  // updated: OrderInfo
  promocode: {
    used: boolean
    status: number
    promocode: string
    info?: {
      active: boolean
      active_from?: number
      active_until?: number
    }
  }
}
export interface ApplyPromocodeMutationVariables {
  order_id: GQL_ID
  promocode: string
}

export const GQL_MUTATION_APPLY_PROMOCODE = gql`
  mutation($order_id: ID!, $promocode: String!) {
    applyPromocode(order_id: $order_id, promocode: $promocode) {
      used
      status
      promocode
      # updating order instance here
      # TODO: drop it and make order refetch less magical
      order {
        id
        promocode {
          id
          code
        }
      }
      info {
        active
        active_from
        active_until
      }
    }
  }
`
